import { reactive as s, provide as u, inject as C, ref as f, onMounted as g, unref as r, onBeforeUnmount as A } from "vue";
function d(n, t) {
  return (t == null ? void 0 : t.target) && n && (t.target === n || n.contains(t.target));
}
const e = Symbol("dsActionsContext");
function x() {
  const n = s({
    actionContainers: []
  });
  function t(o) {
    n.actionContainers.push(o);
  }
  function c(o) {
    const i = n.actionContainers.indexOf(o);
    i !== -1 && n.actionContainers.splice(i, 1);
  }
  function a(o) {
    return n.actionContainers.some((i) => d(i, o));
  }
  return n.registerActionContainer = t, n.unregisterActionContainer = c, n.containsEventTarget = a, u(e, n), n;
}
function l() {
  const n = C(e), t = f(null);
  return n ? (g(() => {
    n.registerActionContainer(r(t));
  }), A(() => {
    n.unregisterActionContainer(r(t));
  }), t) : (console.warn("createActionsContainer must be used within an actions provider"), t);
}
export {
  e as actionsKey,
  l as createActionsContainer,
  x as createActionsProvider
};
//# sourceMappingURL=design-system.es31.js.map
